import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import BaseUrl from '../../ApiServices/BaseUrl';
import { FaMapMarkerAlt, FaInfoCircle, FaPhone, FaUser, FaStar, FaPlus } from "react-icons/fa";
import defaultImage from "../../Pages/Images/young-beautiful-teacher-toddlers-playing-260nw-1690362274.webp";
import './ManageTrainings.css';
import { useNavigate } from 'react-router-dom';

function ManageTrainings() {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTrainings();
  }, []);

  const fetchTrainings = async () => {
    try {
      const response = await fetch(`${BaseUrl}/trainings/all`);
      if (!response.ok) {
        throw new Error('Failed to fetch trainings');
      }
      const data = await response.json();
      setTrainings(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleNavigateToAddTraining = () => {
    navigate('/add-training');
  };

  if (loading) {
    return (
      <>
        <AdminNavbar />
        <div className="manage-trainings-container">
          <div className="text-center mt-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading trainings...</p>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <AdminNavbar />
        <div className="manage-trainings-container">
          <div className="alert alert-danger text-center mt-5" role="alert">
            Error: {error}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AdminNavbar />
      <Container className="manage-trainings-container" style={{marginTop: "100px"}}>
        {/* Header Section with Button */}
            <div className="d-flex flex-row justify-content-between align-items-center mb-4">
          <h2 className="training-title-wrapper mb-2">
            <div className='Training-title'>
              <FaUser className="training-title-icon" />
              <span className="training-title-text">Manage Training</span>
            </div>
          </h2>
          <Button 
            variant="primary" 
            onClick={handleNavigateToAddTraining}
            className="manage-training-btn"
          >
            <FaPlus className="me-2" />
            Manage Training
          </Button>
        </div>

        {/* Training Cards Section */}
        <div className="trng-container trng-training-container">
          <div className="text-center mb-4 trng-training-header">
            <h2 className="trng-title">
              <i className="fas fa-phone-alt trng-contact-icon"></i> 
              <span className="trng-title-text">The Best Domestic Workers Trainings</span>
            </h2>
            <p className="trng-subtitle">
              A lot of trainings are available to provide to Foreign Domestic Workers more experience 
              (caregiver certificate, CPR and first aid classes, childcare) and help employer to improve 
              the skills of their helpers (cooking, housekeeping, languages, driving..). We are listing 
              the best trainings for any helper.
            </p>
          </div>

          {/* Cards Grid */}
          <div className="row justify-content-center">
            {trainings.map((training) => (
              <div key={training.id} className="col-md-4 mb-4">
                <div className="trng-card trng-service-card h-100 shadow-sm position-relative">
                  {/* Banner Image */}
                  <img 
                    src={training.back_profile || defaultImage} 
                    alt={`${training.training_title} Banner`} 
                    className="trng-card-img-top trng-banner-img" 
                  />

                  {/* Logo */}
                  <img 
                    src={training.profile_image || defaultImage} 
                    alt={`${training.training_title} Logo`} 
                    className="rounded-circle trng-logo-img" 
                  />

                  {/* Rating */}
                  <div className="trng-rating-badge">
                    <FaStar className="trng-star-icon" />
                    <span>{training.rating}</span>
                  </div>

                  <div className="trng-card-body">
                    {/* Location */}
                    <div className="d-flex justify-content-end mb-2">
                      <span className="trng-location-text">
                        <FaMapMarkerAlt className="trng-location-icon" /> {training.location}
                      </span>
                    </div>

                    <h3 className="trng-tenderheart-home">{training.training_title}</h3>
                    <p className="trng-card-text text-black trng-description">
                      {training.description}
                    </p>

                    <h5 className="mt-4 trng-service-subheading text-blue text-start">
                      Our Services:
                    </h5>
                    <span className="trng-badge trng-training-badge">{training.our_services}</span>

                    {/* <div className="d-flex justify-content-around mt-4 trng-card-buttons">
                      <button className="btn btn-success rounded-pill trng-contact-btn">
                        <FaPhone /> CONTACT US
                      </button>
                      <button 
                        className="btn btn-warning rounded-pill trng-details-btn"
                      >
                        <FaInfoCircle /> MORE DETAILS
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </>
  );
}

export default ManageTrainings;
